// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2viYd","label":"Completed_label__3NAoJ"};